import {Directive, Input, Output, EventEmitter, HostListener} from '@angular/core';


/*
** Can edit input if 2 decimal provided
** Can't be used because key position in string is not known
*/
@Directive({
    selector: '[limit-to]',
})
export class LimitToDirective {

    @HostListener('keypress') onKeypress(e) {
        const limit = +this.limitTo;
        if (e.target.value && e.target.value.split('.').length > 1) {
            const afterCom = e.target.value.split('.')[1].length;
            if (afterCom >= limit) {
                e.preventDefault();
            }
        }
    }

    @Input('limit-to') limitTo;
}
